<template>
    <b-container>
      <b-form-group>
          <b-input-group :prepend="$t('site.fullName')">
            <b-input v-model="fullName" :placeholder="$t('site.fullName')"></b-input>
          </b-input-group>
          <p style="margin: 12px 12px;"></p>
          <b-card>
              <template v-slot:header>
                  <p style="margin-bottom: 0px; text-align: left;">Please enter your credit card info below</p>
              </template>
              <div class="card-fields" :class="{ 'card-fields-loading': stripeLoading }">
                <div id="card-number-element" class="card-field card-number-field"></div>
                <div id="card-expiry-element" class="card-field"></div>
                <div id="card-cvc-element" class="card-field"></div>
                <input
                  v-model="postalCode"
                  class="StripeElement card-field postal-code-field"
                  :class="{ 'StripeElement--invalid': showPostalCodeError }"
                  autocomplete="postal-code"
                  :disabled="stripeLoading"
                  @input="showPostalCodeError = false"
                  placeholder="ZIP code"
                  required
                  type="text"
                >
                <b-form-invalid-feedback :force-show="showPostalCodeError">
                  ZIP code is required
                </b-form-invalid-feedback>
              </div>
              <p :hidden="!stripeLoading">Waiting for Credit card company, we do not store your credit card information, 
                <br/>Establishing connection...</p>
              <b-button variant="secondary" @click="payWithStripe" :disabled="stripeLoading" style="margin-bottom: 24px;">Pay with credit card</b-button>
              <br>
              <p>If you have an agreement with the CPA, you can skip the online payment by clicking this button.</p>
              <b-button variant="secondary" @click="payOffline" :disabled="payOfflineLoading">Pay offline</b-button>
          </b-card>
      </b-form-group>
    </b-container>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { firebase } from '../util/firebase';
import {Util} from '../util/Util';

@Component({
  components: {
  },
})
export default class StripePay extends Vue {

    protected stripeData: Object = {}

    protected stripeLoading: boolean = false

    protected payOfflineLoading: boolean = false

    protected price: number = 0

    protected contactId: string = '';

    protected engagementId: string = '';

    protected fullName: string = '';

    protected postalCode: string = '';

    protected showPostalCodeError: boolean = false;

    protected years: number = 0;

    protected surveyName: string = '';

    protected created() {
      const recaptchaScript = document.createElement('script');
      recaptchaScript.setAttribute('src', 'https://js.stripe.com/v3/');
      document.head.appendChild(recaptchaScript);

      (this as any).$analytics.logEvent('quote_accepted');
      

      this.stripeLoading = true
      this.contactId = Util.of(sessionStorage.getItem('contactId'), '');
      this.engagementId = Util.of(sessionStorage.getItem('engagementId'), '');
      this.fullName = Util.of(sessionStorage.getItem('fullName'), '');
      firebase.firestore().collection('contacts').doc(this.contactId).collection('engagements').doc(this.engagementId).get().then(async (doc) => {
          this.price = parseInt(doc.data().total_price.substring(1));
          this.years = doc.data().years
          const surveyDoc = await firebase.firestore().collection('questionaries').doc(doc.data().survey_id).get()
          this.surveyName = surveyDoc.data().name;
          (this as any).$analytics.logEvent('begin_checkout', {
            items: [
              {
                id: this.contactId,
                name: this.surveyName,
                list_name: 'not set',
                brand: 'global-accountant',
                category: 'not set',
                variant: 'not set',
                list_position: 1,
                quantity: this.years,
                price: this.price,
                checkout_option: 'stripe',
              },
            ],
          });
          fetch('/createPaymentIntent', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              amount: this.price * 100,
            }),
          })
          .then((result) => {
            return result.json();
          })
          .then((data) => {
            // Set up credit card input elements
            const windowX: any = window;
            const stripe = windowX.Stripe(data.publishablekey);
            const elements = stripe.elements();
            const elementStyle = {
              base: {
                'color': '#32325D',
                'fontWeight': 500,
                'fontFamily': 'Inter UI, Open Sans, Segoe UI, sans-serif',
                'fontSize': '16px',
                'fontSmoothing': 'antialiased',

                '::placeholder': {
                  color: '#CFD7DF',
                },
              },
              invalid: {
                color: '#E25950',
              },
            };
            const cardNumber = elements.create('cardNumber', {
              showIcon: true,
              style: elementStyle,
            });
            const cardExpiry = elements.create('cardExpiry', {
              style: elementStyle,
            });
            const cardCvc = elements.create('cardCvc', {
              style: elementStyle,
            });
            cardNumber.mount('#card-number-element');
            cardExpiry.mount('#card-expiry-element');
            cardCvc.mount('#card-cvc-element');

            this.stripeData = {
              stripe,
              card: cardNumber,
              clientSecret: data.clientSecret,
              id: data.id,
            }

            this.stripeLoading = false
          })
      })
    }

    private payWithStripe() {
        if (!this.postalCode.trim()) {
          this.showPostalCodeError = true
          return
        }

        this.showPostalCodeError = false
        this.stripeLoading = true
        const self: any = this;
        // Set up Pay button handler
        const data = {
          card: self.stripeData.card,
          billing_details: {
            name: self.fullName,
            address: {
              postal_code: self.postalCode.trim(),
            },
          },
        };

        // Initiate the payment.
        // If authentication is required, confirmCardPayment will automatically display a modal

        // Use save_payment_method to indicate that you want to save the card
        // Use setup_future_usage to tell Stripe how you plan on charging the card
        self.stripeData.stripe
          .confirmCardPayment(self.stripeData.clientSecret, {
            payment_method: data,
            setup_future_usage: 'off_session',
          })
          .then((result) => {
            if (result.error) {
              // error handling
              this.stripeLoading = false
            } else if (result.paymentIntent) {
              // 将customerId保存在contact下
              fetch('/createCustomer', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  paymentMethod: result.paymentIntent.payment_method,
                }),
              })
              .then((result) => {
                return result.json();
              })
              .then((data) => {
                firebase.firestore().collection('contacts').doc(this.contactId).set({
                  customer_id: data.customerId,
                }, {merge: true});
                this.stripeLoading = false
              })
              // 将paymentIntent保存在engagement下
              firebase.firestore().collection('contacts').doc(this.contactId).collection('engagements').doc(this.engagementId).get().then((response) => {
                let pay_list: any[] = [];
                if (response.data().payment_intent_list) {
                  pay_list = response.data().payment_intent_list;
                }
                pay_list.push(result.paymentIntent);
                firebase.firestore().collection('contacts').doc(this.contactId).collection('engagements').doc(this.engagementId).set({
                  payment_intent_list: pay_list,
                  status: 'DepositPaid',
                }, {merge: true}).then((response) => {
                  this.$emit('paymentCompleted', this.surveyName, this.years, 'stripe')
                })
              });
            }
          });
    }

    private payOffline() {
      this.payOfflineLoading = true
      firebase.firestore().collection('contacts').doc(this.contactId).collection('engagements').doc(this.engagementId).set({
        status: 'DepositPaid',
      }, {merge: true}).then((response) => {
        this.$emit('paymentCompleted', this.surveyName, this.years, 'pay_later')
        this.payOfflineLoading = false
      })
    }
}
</script>
<style scoped>
  .container {
    width: 55%;
  }

  @media screen and (max-width: 991px) {
    .container {
      padding-left: 0;
      padding-right: 0;
      width: 100%;
    }
  }

  .StripeElement {
    box-sizing: border-box;

    height: 40px;

    padding: 10px 12px;
    margin-bottom: 24px;

    border: 1px solid #ced4da;
    border-radius: 4px;
    background-color: white;

    box-shadow: 0 1px 3px 0 #e6ebf1;
    -webkit-transition: box-shadow 150ms ease;
    transition: box-shadow 150ms ease;
  }

  .card-fields {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 24px;
  }

  .card-field {
    flex: 1 1 160px;
    margin-bottom: 0;
    min-width: 0;
  }

  .card-number-field {
    flex-basis: 100%;
  }

  .postal-code-field {
    color: #32325D;
    font-family: "Inter UI", "Open Sans", "Segoe UI", sans-serif;
    font-size: 16px;
    font-weight: 500;
    outline: none;
    width: 100%;
  }

  .postal-code-field::placeholder {
    color: #CFD7DF;
  }

  .card-fields-loading .postal-code-field {
    opacity: 0;
    pointer-events: none;
  }

  @media screen and (max-width: 575px) {
    .card-fields {
      display: block;
    }

    .card-field {
      margin-bottom: 12px;
      width: 100%;
    }
  }

  .StripeElement--focus {
    box-shadow: 0 1px 3px 0 #cfd7df;
  }

  .StripeElement--invalid {
    border-color: #fa755a;
  }

  .StripeElement--webkit-autofill {
    background-color: #fefde5 !important;
  }
</style>
